import { Component, OnInit } from '@angular/core';
import { HelperService } from '../service/helper/helper.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.css']
})
export class ImportComponent implements OnInit {
  public seed;
  public passPhrase;
  public confirmPassPhrase;
  constructor(public router: Router, public helper: HelperService) { }

  ngOnInit() {
  }

  back() {
    this.router.navigate(['login']);
  }

  confirmSeed() {
    if (!this.passPhrase) {
      Swal.fire({
        title: 'Error',
        text: 'Please enter wallet PIN',
        type: 'info'
      })
      this.passPhrase = '';
      return;
    }
    if(this.passPhrase != this.confirmPassPhrase){
      Swal.fire({
        title: 'Error',
        text: 'Passkeys doesn\'t match',
        type: 'info'
      })
      this.passPhrase = '';
      this.confirmPassPhrase = ''
      return;
    }
    else{
      Swal.fire({
        title: '',
        text: "Wallet Imported",
        type: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Go to Login page'
      }).then((result) => {
        if (result.value) {

          this.helper.encrypt(this.seed, this.passPhrase);
    this.router.navigate(['login']);
        }
      })

    }

  }

}
